import { api } from './api';
import type { SidebarCountersResponse } from '@/types/sidebarCounters';

export async function getSidebarCounters(): Promise<SidebarCountersResponse> {
  const { data } = await api.get<SidebarCountersResponse>('/crm/sidebar-counters');
  return data;
}
